/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IMoeArticleListItemViewProps } from './moe-article-list-item';

export default (props: IMoeArticleListItemViewProps) => {
    const {
        heading,
        paragraph,
        thumbnailImage,
        articleListItemContainer,
        articleListItemImageContainer,
        articleListItemHeadingContainer,
        articleListItem,
        config
    } = props;

    const { redirectionUrl } = props.config;

    const renderArticleListItemContent = (): JSX.Element => {
        return (
            <Node {...articleListItemContainer}>
                {thumbnailImage && <Node {...articleListItemImageContainer}>{thumbnailImage}</Node>}
                <Node {...articleListItemHeadingContainer}>
                    <a href={redirectionUrl?.linkUrl.destinationUrl || ''} className='ms-article-list__item-heading' tabIndex={0}>
                        {heading}
                    </a>
                    {config.publishedDate && <div className='ms-article-list__item-pbdate'>{config.publishedDate}</div>}
                    {paragraph ? (
                        <div tabIndex={0}>{paragraph}</div>
                    ) : (
                        <div className='ms-article-list__item-text'>
                            <p>--- </p>
                        </div>
                    )}
                    <span>—</span>
                    <a className='ms-article-list__item-link' href={redirectionUrl?.linkUrl.destinationUrl || ''} tabIndex={0}>
                        Read More
                    </a>
                </Node>
            </Node>
        );
    };

    return <Module {...articleListItem}>{renderArticleListItemContent()}</Module>;
};
